export const selectDolls = state => state.doll.dolls;
export const selectSaveError = state => state.doll.saveError;
export const selectLoading = state => state.doll.dollsLoading;
export const selectTitleLevel = state => state.doll.titleLevel;
export const selectDegreeLevel = state => state.doll.degreeLevel;
export const selectTitleGreatness = state => state.doll.titleGreatness;
export const selectDegreeGreatness = state => state.doll.degreeGreatness;
export const selectStrength = state => state.doll.strength;
export const selectDexterity = state => state.doll.dexterity;
export const selectAccuracy = state => state.doll.accuracy;
export const selectEndurance = state => state.doll.endurance;
export const selectEarth = state => state.doll.earth;
export const selectAir = state => state.doll.air;
export const selectWater = state => state.doll.water;
export const selectFire = state => state.doll.fire;
export const selectStrengthStats = state => state.doll.strengthStats;
export const selectDexterityStats = state => state.doll.dexterityStats;
export const selectAccuracyStats = state => state.doll.accuracyStats;
export const selectEnduranceStats = state => state.doll.enduranceStats;
export const selectEarthStats = state => state.doll.earthStats;
export const selectAirStats = state => state.doll.airStats;
export const selectWaterStats = state => state.doll.waterStats;
export const selectFireStats = state => state.doll.fireStats;
export const selectHPStats = state => state.doll.hpStats;
export const selectPranaStats = state => state.doll.pranaStats;
export const selectHP = state => state.doll.hp;
export const selectPrana = state => state.doll.prana;
export const selectPDStats = state => state.doll.pdStats;
export const selectMDStats = state => state.doll.mdStats;
export const selectPAStats = state => state.doll.paStats;
export const selectMAStats = state => state.doll.maStats;
export const selectTitleStats = state => state.doll.titleStats;
export const selectDegreeStats = state => state.doll.degreeStats;
export const selectHelmet = state => state.doll.helmet;
export const selectAmulet = state => state.doll.amulet;
export const selectGloves = state => state.doll.gloves;
export const selectJacket = state => state.doll.jacket;
export const selectShield = state => state.doll.shield;
export const selectBracelet1 = state => state.doll.bracelet1;
export const selectBracelet2 = state => state.doll.bracelet2;
export const selectBelt = state => state.doll.belt;
export const selectRing1 = state => state.doll.ring1;
export const selectRing2 = state => state.doll.ring2;
export const selectRing3 = state => state.doll.ring3;
export const selectRing4 = state => state.doll.ring4;
export const selectPants = state => state.doll.pants;
export const selectBoots = state => state.doll.boots;
export const selectWeapon = state => state.doll.weapon;
export const selectProfession = state => state.doll.profession;
export const selectBuff1 = state => state.doll.buff1;
export const selectBuff2 = state => state.doll.buff2;
export const selectBuff3 = state => state.doll.buff3;
export const selectBuff4 = state => state.doll.buff4;
export const selectBuff5 = state => state.doll.buff5;
export const selectBuff6 = state => state.doll.buff6;
export const selectBuff7 = state => state.doll.buff7;
export const selectBuff8 = state => state.doll.buff8;
export const selectBuff9 = state => state.doll.buff9;
export const selectBuff10 = state => state.doll.buff10;
export const selectCrystalPD = state => state.doll.crystalpd;
export const selectCrystalMD = state => state.doll.crystalmd;
export const selectCrystalPA = state => state.doll.crystalpa;
export const selectCrystalMA = state => state.doll.crystalma;
export const selectSlot1 = state => state.doll.slot1;
export const selectSlot2 = state => state.doll.slot2;
export const selectSlot3 = state => state.doll.slot3;
export const selectSlot4 = state => state.doll.slot4;
export const selectSlot5 = state => state.doll.slot5;
export const selectSlot6 = state => state.doll.slot6;
export const selectSlot7 = state => state.doll.slot7;
export const selectSlot8 = state => state.doll.slot8;
export const selectSlot9 = state => state.doll.slot9;
export const selectSlot10 = state => state.doll.slot10;
export const selectReqProfession = state => state.doll.reqProfession;
export const selectReqProfessionLevel = state => state.doll.reqProfessionLevel;
export const selectReqStrength = state => state.doll.reqStrength;
export const selectReqDexterity = state => state.doll.reqDexterity;
export const selectReqAccuracy = state => state.doll.reqAccuracy;
export const selectReqEndurance = state => state.doll.reqEndurance;
export const selectReqEarth = state => state.doll.reqEarth;
export const selectReqAir = state => state.doll.reqAir;
export const selectReqWater = state => state.doll.reqWater;
export const selectReqFire = state => state.doll.reqFire;
export const selectPrefixes = state => state.doll.prefixes;
export const selectOtherDoll = state => state.doll.otherDoll;
export const selectOtherDolls = state => state.doll.otherDolls;
export const selectDefaultDolls = state => state.doll.defaultDolls;
export const selectDoll = state => state.doll.doll;
export const selectDollError = state => state.doll.dollError;
export const selectDollName = state => state.doll.dollName;
export const selectDollDetailsLoading = state => state.doll.dollDetailsLoading;